<template>
  <div class="contact">
    <!-- <p style="background-color: #f47e20; color: white; font-weight: bolder; padding: 10px;">** This page will be down for maintenance on July 25, 2023 from 6:30am to 8:00am. We apologize for any incovenience this may cause. Please direct questions to info@bcamsc.org. **</p> -->
     <!-- <h3>Organism Code Redemption is closed for the 2025-26 School Year</h3> -->
     <!-- <p>Thank you for your interest in our organism program. The redemption window for organism codes is now closed for the current school year.</p> -->
     <!-- <p>Redemptions will reopen in the summer for the 2026-27 school year. Please check back then to redeem your 2026-27 organism codes.</p> -->
     <!-- <p><b>Questions?</b> If you have questions or need assistance, please contact Suzan Luther at suzan@bcamsc.org.</p> -->
    <h3>Please select a unit to place a new order</h3>
      <h4>NGSS Units</h4>
      <ul>
        <li><router-link to="/orgcardform" @click.native="selectUnit('KLNG')">KLNG - Plants and Animals Live Here (plants, worms, pill bugs)</router-link></li>
        <li><router-link to="/orgcardform" @click.native="selectUnit('1LNG')">1LNG - Plant and Animal Traits (fiddler crabs, plants)</router-link></li>
        <li><router-link to="/orgcardform" @click.native="selectUnit('2LNG')">2LNG - Plant and Animal Relationships (plants)</router-link></li>
        <!-- <li><a>3LNG - Life Cycles and Survival in an Ecosystem (frog eggs/tadpoles) <span style="color:red;">**CLOSED**</span></a></li> -->
        <li><router-link to="/orgcardform" @click.native="selectUnit('3LNG')">3LNG - Life Cycles and Survival in an Ecosystem (frog eggs/tadpoles)</router-link></li>
        <li><router-link to="/orgcardform" @click.native="selectUnit('5LNG')">5LNG - Matter and Energy in an Ecosystem (plants, guppies, snail)</router-link></li>
        <li><router-link to="/orgcardform" @click.native="selectUnit('MSLNG1')">MSLNG1 - Stability and Change in an Ecosystem (millipedes, anoles, bess beetles, plants )</router-link></li>
      </ul>
      <!-- <h4>Pre-NGSS Units</h4>
      <ul>
        <li><router-link to="/orgcardform" @click.native="selectUnit('KLS')">KLS - Is It Living? (worms)</router-link></li>
        <li><router-link to="/orgcardform" @click.native="selectUnit('1LS')">1LS - An Animal's Life (butterfly)</router-link></li>
        <li><router-link to="/orgcardform" @click.native="selectUnit('2LS')">2LS - A Plant's Life (plants)</router-link></li>
        <li><router-link to="/orgcardform" @click.native="selectUnit('3LS')">3LS - Organisms Have Character (plants, bess beetles, crayfish)</router-link></li>
        <li><router-link to="/orgcardform" @click.native="selectUnit('4LS')">4LS - Organisms In Their Environment (aquatic frogs, snails, guppies)</router-link></li>
        <li><router-link to="/orgcardform" @click.native="selectUnit('5LS')">5LS - Systems and Survival(hermit crab, tree frogs, plants)</router-link></li>
        <li><router-link to="/orgcardform" @click.native="selectUnit('6LS')">6LS - Energy in an Ecosystem (millipedes, bess beetles, chameleons, plants)</router-link></li>
      </ul> -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
const fb = require('./../../firebase/firebase')

export default {
  data() {
    return {}
  },
  computed: {
    ...mapState([ 'confirmationMsg' ])
  },
  methods: {
    selectUnit(unitId) {
      fb.auth.signInAnonymously()
      this.$store.commit('SET_ORG_CARD_KIT_ID', unitId)
      this.$store.commit('SET_CONFIRMATION_MSG', null)
      console.log(unitId)
    }
  }
}
</script>

<style lang="css" scoped>
.contact p {
  padding: 20px 20px 0 20px;
}
</style>
